import Swiper, { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';

function initialize() {
    new Swiper('.list-news .swiper', {
        modules: [Pagination],

        slidesPerView: 1,
        spaceBetween: 24,

        watchOverflow: true,

        pagination: {
            el: '.list-news .swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
    });
}
initialize();
